(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_common/banner-helpers/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/banner_common/banner-helpers/assets/javascripts/prescript.js');
svs.banner_common = svs.banner_common || {};
svs.banner_common.banner_helpers = svs.banner_common.banner_helpers || {};


 })(window);